import { useState } from 'react';

const useInput = initialValue => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = event => {
    setValue(event.target.value);

    if (error) {
      setError(false);
      setErrorMessage('');
    }
  };

  return {
    value,
    onChange: handleChange,
    setValue,
    error,
    setError,
    helperText: errorMessage,
    setErrorMessage,
    bind: {
      value,
      onChange: handleChange,
      helperText: errorMessage,
      error,
    },
  };
};

export default useInput;
